import { render } from "./cold-chain.vue?vue&type=template&id=137a45ba&scoped=true"
import script from "./cold-chain.vue?vue&type=script&lang=js"
export * from "./cold-chain.vue?vue&type=script&lang=js"

import "./cold-chain.vue?vue&type=style&index=0&id=137a45ba&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137a45ba"]])

export default __exports__